import React, { useEffect, useRef, useState, useSyncExternalStore } from 'react';
import { getDialog, subscribeDialogs, settleDialog } from '../../utils/appDialogs';

function AppDialog({ request }) {
  const ref = useRef(null);
  const [value, setValue] = useState(request.defaultValue);
  const isPrompt = request.type === 'prompt';
  const cancel = () => settleDialog(request, isPrompt ? null : false);
  useEffect(() => {
    const dialog = ref.current;
    const previousFocus = document.activeElement;
    dialog.showModal();
    const target = dialog.querySelector(isPrompt ? 'input' : '[data-initial-focus]');
    target?.focus();
    if (isPrompt) target?.select();
    return () => {
      dialog.close();
      if (previousFocus?.isConnected) previousFocus.focus();
    };
  }, [isPrompt]);
  return (
    <dialog ref={ref} className="app-dialog" aria-labelledby="app-dialog-title"
      aria-describedby="app-dialog-message" onCancel={event => { event.preventDefault(); cancel(); }}>
      <form onSubmit={event => {
        event.preventDefault();
        settleDialog(request, isPrompt ? value : true);
      }}>
        <h2 id="app-dialog-title" className="text-xl font-semibold mb-4">
          {request.type === 'confirm' ? 'Please confirm' : isPrompt ? 'Enter details' : 'Notice'}
        </h2>
        <p id="app-dialog-message" className="whitespace-pre-wrap mb-4">{request.message}</p>
        {isPrompt && <input aria-label={request.message} className="input w-full mb-4"
          value={value} onChange={event => setValue(event.target.value)} />}
        <div className="flex justify-end gap-3">
          {request.type !== 'alert' && <button type="button" className="btn btn-secondary"
            data-initial-focus onClick={cancel}>Cancel</button>}
          <button type="submit" className="btn btn-primary"
            data-initial-focus={request.type === 'alert' ? true : undefined}>
            {request.type === 'confirm' ? 'Confirm' : 'OK'}
          </button>
        </div>
      </form>
    </dialog>
  );
}

export default function AppDialogHost() {
  const request = useSyncExternalStore(subscribeDialogs, getDialog);
  return request ? <AppDialog key={request.id} request={request} /> : null;
}
